import domain from './domain';

// Reset pickable team participant users
export const resetTeamPickableParticipantUsers = domain.createEvent('resetTeamPickableParticipantUsers');

// Reset team state
export const resetTeam = domain.createEvent('resetTeam');

// Reset team occupancy
export const resetTeamOccupancy = domain.createEvent('resetTeamOccupancy');
